import { render, staticRenderFns } from "./ManageScholarshipsList.vue?vue&type=template&id=15e61d17&"
import script from "./ManageScholarshipsList.vue?vue&type=script&lang=js&"
export * from "./ManageScholarshipsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports